import React from 'react'
import styled from 'styled-components'

import Item from './Item'

const Items = [
  {
    title: 'Videos',
    icon: 'NodeDevPlay.svg',
    path: '/videos'
  },
  {
    title: 'Blogs',
    icon: 'NodeDevBlog.svg',
    path: '/blogs'
  },
  {
    title: 'Node.JS Binary',
    icon: 'NodeDevDistros.svg',
    path: '/node-binary'
  },
  {
    title: 'Community',
    icon: 'NodeDevCommunity.svg',
    path: '/community'
  }
]

const Section = styled.section`
  background-color: #f5f7f7;
`
const Menu = () => (
  <Section className='pull-top-150px'>
    <div className='container'>
      <div className='row'>
        {
          Items.map((item, index) => <Item key={index} {...item} />)
        }
      </div>
    </div>
  </Section>
)

export default Menu
